import { Pipe, PipeTransform } from '@angular/core';

// using this so fix (updating publish links) applies to old event lists as well as new ones
@Pipe({
    name: 'publishLinkListFix',
    standalone: true
})
export class PublishLinkListFixPipe implements PipeTransform {
  constructor() {}
  transform(url) {
    if (url.includes("publish")) return url
    const parts = url.split("/")
    const fixedUrl = `${parts.slice(0,parts.length-1).join("/")}/publish/${parts[parts.length-1]}`
    return fixedUrl
  }
}

